import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function ReservedCodePicker({ onPick }) {
  const [items, setItems] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => { const t = setTimeout(() => api.get("/identifiers/reserved", { params: { q } }).then(({ data }) => setItems(data.items)).catch(() => setItems([])), 200); return () => clearTimeout(t); }, [q]);
  return (
    <div className="col-span-7 rounded border bg-white p-2" data-testid="po-reserved-picker">
      <input placeholder="Rezerve kod ara (ör. 04)" value={q} onChange={(e) => setQ(e.target.value)} className="h-8 w-48 rounded border px-2 text-[13px]" data-testid="po-reserved-search" />
      <div className="mt-2 flex max-h-32 flex-wrap gap-1 overflow-auto">
        {!items ? null : items.length === 0 ? <span className="text-[12px] text-slate-400">Rezerve, atanmamış çift yok (Ürünler → Kod Üret)</span> : items.map((p) => (
          <button key={p.code} onClick={() => onPick(p)} className="rounded border px-2 py-0.5 font-mono text-[12px] hover:bg-amber-50" data-testid={`po-reserved-${p.code}`}>{p.code} · {p.gtin}</button>))}
      </div>
    </div>
  );
}
